import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import {
  GetTaskContexts_taskContextConnections as GetTaskContextsContextGenerated,
  GetTaskContexts as GetTaskContextsGenerated,
  GetTaskContextsVariables as GetTaskContextsVariablesGenerated,
} from "core/queries/__generated__/GetTaskContexts";

export interface GetTaskContextsVariables
  extends GetTaskContextsVariablesGenerated {}
export interface GetTaskContextsResponse extends GetTaskContextsGenerated {}
export interface GetTaskContextsContext
  extends GetTaskContextsContextGenerated {}

export const getTaskContexts = gql`
  query GetTaskContexts(
    $cursor: String = "0"
    $limit: Int = 10000
    $filters: TaskContextFilterInput!
  ) {
    taskContextConnections(
      pagination: { cursor: $cursor, limit: $limit }
      filters: $filters
    ) {
      serializedTreeStructuredTaskContexts
    }
  }
`;

export interface UseGetTaskContextsQueryOptions {
  skip: boolean;
  variables: GetTaskContextsVariables;
}

export const useGetTaskContextsQuery = ({
  skip = false,
  variables,
}: UseGetTaskContextsQueryOptions) =>
  useQuery<GetTaskContextsResponse, GetTaskContextsVariables>(getTaskContexts, {
    skip,
    variables,
  });
